var _style, _path, _path2, _ellipse, _ellipse2, _g, _g2, _g3, _g4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelectPosture(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 220",
    style: {
      enableBackground: "new 0 0 200 220"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F5F5F5;}\n\t.st1{fill:#E1E1E1;}\n\t.st2{fill:#00A0DF;}\n\t.st3{display:none;opacity:0.1;}\n\t.st4{fill:#FFFFFF;}\n\t.st5{fill:#009CDF;}\n\t.st6{fill:#0099F3;}\n\t.st7{opacity:0.4;fill:#FFFFFF;}\n\t.st8{opacity:0.1;}\n\t.st9{fill:#ECECEC;}\n\t.st10{fill:#FAFAFA;}\n\t.st11{fill:#062354;}\n\t.st12{fill:#031437;}\n\t.st13{fill:#121F3D;}\n\t.st14{fill:#B8E6F4;}\n\t.st15{fill:#192853;}\n\t.st16{fill:#0E182D;}\n\t.st17{fill:#1A2E35;}\n\t.st18{fill:#A4D5E0;}\n\t.st19{fill:#9BD1DD;}\n\t.st20{fill:#9FCDD8;}\n\t.st21{fill:#00AFF1;}\n\t.st22{fill:#80D0E3;}\n\t.st23{fill:#92C7D2;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Floor_10_",
    className: "st0",
    d: "M31.31,201.76c38.13,20.1,99.96,20.1,138.09,0c38.13-20.1,38.13-52.68,0-72.78 c-38.13-20.1-99.96-20.1-138.09,0C-6.82,149.08-6.82,181.66,31.31,201.76z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Shadow_2_",
    className: "st1",
    d: "M18.58,183.52l1.41,0.81c0.45,0.26,1.18,0.26,1.64,0l65.25-37.67c0.45-0.26,0.45-0.68,0-0.94 l-1.4-0.8c-0.45-0.26-1.18-0.26-1.64,0l-65.26,37.66C18.13,182.84,18.13,183.26,18.58,183.52z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Shadow_32_",
    className: "st1",
    cx: 121.3,
    cy: 185.58,
    rx: 30.64,
    ry: 16.8
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Shadow_1_",
    className: "st1",
    cx: 156.7,
    cy: 143.71,
    rx: 23.64,
    ry: 12.96
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Plants_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2661_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2666_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2670_",
    className: "st2",
    d: "M168.26,130.69c-0.04-2.97,2.04-9.14,5.07-13.03c3.03-3.89,7.84-6.77,11.29-5.63 c3.22,1.06,2.92,5.26-0.93,8.1c-3.85,2.83-9.65,6.4-11.3,11.23l-3.52,5.95L168.26,130.69z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2669_",
    className: "st3",
    d: "M168.26,130.69c-0.04-2.97,2.04-9.14,5.07-13.03c3.03-3.89,7.84-6.77,11.29-5.63 c3.22,1.06,2.92,5.26-0.93,8.1c-3.85,2.83-9.65,6.4-11.3,11.23l-3.52,5.95L168.26,130.69z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2663_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2664_",
    className: "st4",
    d: "M168.09,134.76c0.09-0.01,0.18-0.08,0.19-0.18c1.87-10.15,9.96-18.49,14.85-20.37 c0.11-0.04,0.17-0.17,0.12-0.28c-0.04-0.11-0.17-0.17-0.28-0.12c-4.98,1.91-13.22,10.38-15.12,20.69 c-0.02,0.12,0.06,0.23,0.17,0.25C168.05,134.76,168.07,134.76,168.09,134.76z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2644_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2658_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2660_",
    className: "st5",
    d: "M169.68,141.22c0.46-1.67,2.46-4.45,5.73-6.76c3.62-2.56,8.22-3.77,9.26-5.74 c1.25-2.37-0.76-4.57-4.5-4.06c-3.74,0.51-10.26,5.7-11.22,13.4L169.68,141.22z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2645_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2646_",
    className: "st4",
    d: "M168.93,139.48c0.08-0.01,0.16-0.06,0.19-0.15c3-8.72,9.59-11.84,12.65-12.28 c0.12-0.02,0.2-0.13,0.18-0.25c-0.02-0.12-0.12-0.2-0.25-0.18c-3.39,0.48-9.93,3.67-13,12.57c-0.04,0.11,0.02,0.24,0.13,0.28 C168.87,139.48,168.9,139.48,168.93,139.48z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Tab_7_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_688_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_708_",
    className: "st6",
    d: "M21.33,182.46l-0.32-0.18c-0.51-0.29-0.92-1.01-0.92-1.6l0-107.61c0-0.59,0.41-1.3,0.92-1.6 l69.34-40.03c0.51-0.29,1.34-0.29,1.85,0l0.32,0.18c0.51,0.29,0.92,1.01,0.92,1.6l0,107.61c0,0.59-0.41,1.3-0.92,1.6l-69.34,40.03 C22.67,182.75,21.84,182.75,21.33,182.46z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_707_",
    className: "st7",
    d: "M93.43,33.07c-0.06-0.48-0.45-0.65-0.91-0.39L23.18,72.72c-0.26,0.15-0.48,0.4-0.65,0.69 l-2.16-1.25c0.16-0.29,0.4-0.54,0.65-0.69l69.34-40.03c0.51-0.29,1.34-0.29,1.85,0l0.32,0.18C92.98,31.89,93.37,32.52,93.43,33.07 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_691_",
    className: "st8",
    d: "M23.02,182.53c-0.51,0.22-1.23,0.19-1.69-0.07l-0.32-0.18c-0.51-0.29-0.92-1.01-0.92-1.6 V73.07c0-0.29,0.1-0.62,0.27-0.91l2.16,1.25c-0.16,0.29-0.27,0.62-0.27,0.91v107.61C22.25,182.45,22.59,182.7,23.02,182.53z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Tabs_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tab_4_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2463_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2467_",
    className: "st9",
    d: "M30.43,143.54l-0.32-0.18c-0.51-0.29-0.92-1.01-0.92-1.6l0-19.34c0-0.59,0.41-1.3,0.92-1.6 l62.95-36.38c0.51-0.29,1.34-0.29,1.85,0l0.32,0.18c0.51,0.29,0.92,1.01,0.92,1.6l0,19.34c0,0.59-0.41,1.3-0.92,1.6l-62.95,36.38 C31.77,143.83,30.94,143.83,30.43,143.54z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2465_",
    className: "st10",
    d: "M96.14,86.07c-0.06-0.48-0.45-0.65-0.91-0.39l-62.95,36.38c-0.26,0.15-0.48,0.4-0.65,0.69 l-2.16-1.25c0.16-0.29,0.4-0.54,0.65-0.69l62.95-36.38c0.51-0.29,1.34-0.29,1.85,0l0.32,0.18 C95.69,84.89,96.08,85.52,96.14,86.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2464_",
    className: "st1",
    d: "M32.12,143.61c-0.51,0.22-1.23,0.19-1.69-0.07l-0.32-0.18c-0.51-0.29-0.92-1.01-0.92-1.6 v-19.34c0-0.29,0.1-0.62,0.27-0.91l2.16,1.25c-0.16,0.29-0.27,0.62-0.27,0.91v19.34C31.35,143.53,31.68,143.78,32.12,143.61z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2459_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2462_",
    className: "st6",
    d: "M41.18,120.77c3.59-2.07,6.5-0.46,6.5,3.6c0,4.06-2.91,9-6.51,11.03 c-3.59,2.03-6.51,0.42-6.51-3.6C34.67,127.78,37.59,122.84,41.18,120.77z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Tab_5_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2468_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2471_",
    className: "st9",
    d: "M30.43,169.75l-0.32-0.18c-0.51-0.29-0.92-1.01-0.92-1.6l0-19.34c0-0.59,0.41-1.3,0.92-1.6 l62.95-36.38c0.51-0.29,1.34-0.29,1.85,0l0.32,0.18c0.51,0.29,0.92,1.01,0.92,1.6l0,19.34c0,0.59-0.41,1.3-0.92,1.6l-62.95,36.38 C31.77,170.05,30.94,170.05,30.43,169.75z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2470_",
    className: "st10",
    d: "M96.14,112.28c-0.06-0.48-0.45-0.65-0.91-0.39l-62.95,36.38 c-0.26,0.15-0.48,0.4-0.65,0.69l-2.16-1.25c0.16-0.29,0.4-0.54,0.65-0.69l62.95-36.38c0.51-0.29,1.34-0.29,1.85,0l0.32,0.18 C95.69,111.1,96.08,111.73,96.14,112.28z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2469_",
    className: "st1",
    d: "M32.12,169.82c-0.51,0.22-1.23,0.19-1.69-0.07l-0.32-0.18c-0.51-0.29-0.92-1.01-0.92-1.6 v-19.34c0-0.29,0.1-0.62,0.27-0.91l2.16,1.25c-0.16,0.29-0.27,0.62-0.27,0.91v19.34C31.35,169.75,31.68,169.99,32.12,169.82z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2460_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2461_",
    className: "st6",
    d: "M41.18,146.98c3.59-2.07,6.5-0.46,6.5,3.6s-2.91,9-6.51,11.03 c-3.59,2.03-6.51,0.42-6.51-3.6C34.67,153.99,37.59,149.05,41.18,146.98z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Tab_6_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2474_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2477_",
    className: "st9",
    d: "M30.43,99.7l-0.32-0.18c-0.51-0.29-0.92-1.01-0.92-1.6l0-19.34c0-0.59,0.41-1.3,0.92-1.6 L93.06,40.6c0.51-0.29,1.34-0.29,1.85,0l0.32,0.18c0.51,0.29,0.92,1.01,0.92,1.6l0,19.34c0,0.59-0.41,1.3-0.92,1.6L32.28,99.7 C31.77,100,30.94,100,30.43,99.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2476_",
    className: "st10",
    d: "M96.14,42.24c-0.06-0.48-0.45-0.65-0.91-0.39L32.27,78.23c-0.26,0.15-0.48,0.4-0.65,0.69 l-2.16-1.25c0.16-0.29,0.4-0.54,0.65-0.69L93.06,40.6c0.51-0.29,1.34-0.29,1.85,0l0.32,0.18C95.69,41.06,96.08,41.68,96.14,42.24 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2475_",
    className: "st1",
    d: "M32.12,99.78c-0.51,0.22-1.23,0.19-1.69-0.07l-0.32-0.18c-0.51-0.29-0.92-1.01-0.92-1.6 V78.58c0-0.29,0.1-0.62,0.27-0.91l2.16,1.25c-0.16,0.29-0.27,0.62-0.27,0.91v19.34C31.35,99.7,31.68,99.95,32.12,99.78z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2472_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2473_",
    className: "st6",
    d: "M41.18,76.93c3.59-2.07,6.5-0.46,6.5,3.6c0,4.06-2.91,9-6.51,11.03 c-3.59,2.03-6.51,0.42-6.51-3.6C34.67,83.95,37.59,79.01,41.18,76.93z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Tab_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2483_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2486_",
    className: "st11",
    d: "M34.85,124.26l-0.32-0.18c-0.51-0.29-0.92-1.01-0.92-1.6l0-19.34 c0-0.59,0.41-1.3,0.92-1.6l62.95-36.38c0.51-0.29,1.34-0.29,1.85,0l0.32,0.18c0.51,0.29,0.92,1.01,0.92,1.6l0,19.34 c0,0.59-0.41,1.3-0.92,1.6L36.7,124.26C36.19,124.56,35.36,124.56,34.85,124.26z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2485_",
    className: "st12",
    d: "M100.57,66.79c-0.06-0.48-0.45-0.65-0.91-0.39L36.7,102.79c-0.26,0.15-0.48,0.4-0.65,0.69 l-2.16-1.25c0.16-0.29,0.4-0.54,0.65-0.69l62.95-36.38c0.51-0.29,1.34-0.29,1.85,0l0.32,0.18 C100.12,65.61,100.51,66.24,100.57,66.79z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2484_",
    className: "st12",
    d: "M36.54,124.33c-0.51,0.22-1.23,0.19-1.69-0.07l-0.32-0.18c-0.51-0.29-0.92-1.01-0.92-1.6 v-19.34c0-0.29,0.1-0.62,0.27-0.91l2.16,1.25c-0.16,0.29-0.27,0.62-0.27,0.91v19.34C35.78,124.26,36.11,124.5,36.54,124.33z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2478_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2482_",
    className: "st0",
    d: "M45.6,101.49c3.59-2.07,6.5-0.46,6.5,3.6c0,4.06-2.91,9-6.51,11.03 c-3.59,2.03-6.51,0.42-6.51-3.6C39.09,108.5,42.01,103.56,45.6,101.49z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2480_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2481_",
    className: "st6",
    d: "M45.73,113.18c-0.31,0.18-0.6,0.19-0.8,0.04l-2.86-2.16c-0.38-0.29-0.33-1.08,0.11-1.78 c0.44-0.7,1.11-1.02,1.49-0.74l1.99,1.51l5.53-11.88c0.35-0.74,1.01-1.24,1.47-1.11c0.47,0.13,0.57,0.83,0.23,1.57l-6.31,13.56 c-0.19,0.41-0.49,0.76-0.81,0.96C45.76,113.16,45.74,113.17,45.73,113.18z"
  })))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_747_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_787_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_794_",
    className: "st13",
    d: "M164.61,138.72v-0.66c-0.26,0.78-1.47,4.11-3.3,5.79c-1.46,1.33-3.45,2.87-3.95,4.35 c-0.53,1.54,2.77,2.06,4.13,1.82c1.58-0.28,3.63-1.18,4.75-2.55c0.78-0.96,1.28-2.1,1.84-2.86c0.56-0.76,1.85-1.6,2.15-2.48 c0.17-0.48-0.03-1.54-0.26-2.43c-0.21-0.82-0.45-1.72-0.73-1.64c0,0.1,0,0.5,0,0.5c-0.34,0.37-1.26,0.74-2.31,0.78 C166.24,139.37,164.6,139.24,164.61,138.72z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_793_",
    className: "st14",
    d: "M159.98,145.02c0.45-0.4,0.91-0.8,1.32-1.17c1.28-1.17,2.26-3.15,2.82-4.5 c0.32-0.77,0.48-1.6,0.48-2.43v-2.63h4.62v4.29v0v0v0.11l-0.02,0.01c-0.22,0.96-2.34,3.52-3.55,5.18 c-0.81,1.12-2.34,2.54-4.18,2.78C159.74,146.89,158.85,146.34,159.98,145.02z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_791_",
    className: "st13",
    d: "M146.58,134.17v-0.66c-0.26,0.78-1.47,4.11-3.3,5.79c-1.46,1.33-3.45,2.87-3.95,4.35 c-0.53,1.54,2.77,2.06,4.13,1.82c1.58-0.28,3.63-1.18,4.75-2.55c0.78-0.96,1.28-2.1,1.84-2.86c0.56-0.76,1.85-1.6,2.15-2.48 c0.17-0.48-0.03-1.54-0.26-2.43c-0.21-0.82-0.45-1.72-0.73-1.64c0,0.1,0,0.5,0,0.5c-0.34,0.37-1.26,0.74-2.31,0.78 C148.21,134.82,146.57,134.68,146.58,134.17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_790_",
    className: "st14",
    d: "M141.95,140.46c0.45-0.4,0.91-0.8,1.32-1.17c1.28-1.17,2.26-3.15,2.82-4.5 c0.32-0.77,0.48-1.6,0.48-2.43v-2.63h4.62v4.29v0v0v0.11l-0.02,0.01c-0.22,0.96-2.34,3.52-3.55,5.18 c-0.81,1.12-2.34,2.54-4.18,2.78C141.71,142.33,140.82,141.78,141.95,140.46z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_789_",
    className: "st15",
    d: "M168.31,66.88c3.58,7.83-0.13,35.4-0.13,35.4c0.11,1.27,1.56,3.77,2.1,9.36 c0.64,6.61-1,23.19-1,23.19s-2.14,1.4-4.67,0.19c0,0-4.41-24.98-5.23-31.55c-0.72-5.73-2.11-18.33-2.11-18.33l-3.94,18.3 c0,0,1.01,3.21,1.25,5.66c0.37,3.86-3.37,21.85-3.37,21.85s-1.59,0.59-4.62,0.14c0,0-1.32-23.87-1.67-28.52 c-0.59-7.82,1.49-32.2,2.92-36.83L168.31,66.88z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_788_",
    className: "st16",
    d: "M157.26,85.14l-1.16-7.27c0,0-4.92-1.02-7.15-3.12c0,0,2.34,2.91,5.82,3.87l1.31,5.6 l-2.28,16.95L157.26,85.14z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_754_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_785_",
    className: "st14",
    d: "M154.34,39.48c0,0-3.47-0.51-5.88,2.64c-1.85,2.41-8.93,11.63-8.93,11.63 s-10.44-5.22-10.95-5.84c-0.51-0.62-0.22-1.87-0.08-2.56c0.14-0.69,0.37-2.22,0.53-2.65c0.27-0.75-0.84-0.55-1.5,0.15 c-0.67,0.72-0.94,2.07-1.27,2.31c-0.33,0.24-2.81-2.62-4.01-4c-1.2-1.38-1.77-2.34-2.58-1.77c-0.58,0.41-0.21,1.23,0.66,2.41 c0.86,1.18,0.99,1.31,1.12,1.56c0.1,0.21-0.22,0.38-0.34,0.49c-0.23,0.21-0.65,0.55-0.68,0.88c-0.02,0.18,0.02,0.36-0.03,0.54 c-0.11,0.39-0.6,0.58-0.74,0.96c-0.1,0.28,0.01,0.59-0.05,0.88c-0.04,0.19-0.14,0.36-0.17,0.54c-0.07,0.37,0.15,0.73,0.39,1.01 c0.85,1.01,2,1.39,3.11,2.01c0.92,0.51,1.88,0.73,2.94,1.21s13.39,9.02,15.34,7.94c1.95-1.08,12.02-12.8,12.02-12.8 C156.14,42.21,154.34,39.48,154.34,39.48z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_784_",
    className: "st0",
    d: "M161.99,39.69L161.99,39.69c4.59,0.32,4.92,2.53,6.07,4.96c0.88,1.85,0.89,3.99,0.22,5.92 l-3.2,9.26c0,0,1.5,3.62,3.24,7.05c-8.03,4.48-18.07,2.13-20.48-1.15c-0.1-0.69,0.52-6.12,0.9-9.67c-1.41-3.55-1.79-5.8-1.19-8.15 c1.11-4.36,5.41-8.6,7.31-8.44L161.99,39.69z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_760_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_781_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_782_",
    className: "st17",
    d: "M157.57,35.88h1.78c5.19,0,9.39-4.2,9.39-9.39v0c0-5.21-4.23-9.44-9.44-9.44h-1.68 c-5.21,0-9.44,4.23-9.44,9.44l0,0C148.18,31.68,152.38,35.88,157.57,35.88z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_780_",
    className: "st17",
    d: "M173.77,40.83L173.77,40.83c-3.06,0-5.55-2.48-5.55-5.55V23.4l0,0 c3.06,0,5.55,2.48,5.55,5.55V40.83z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_779_",
    className: "st17",
    d: "M169.24,21.3l-1.39,2.24c0.62,0.41,1.43,0.25,1.81-0.37 C170.05,22.54,169.86,21.71,169.24,21.3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_777_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_778_",
    className: "st14",
    d: "M151.56,21.21c-1.09,0.64-2.43,3.37-2.3,9.1c0.11,4.85,1.69,6.05,2.48,6.4 c0.79,0.35,2.31,0.14,3.79-0.11v2.91c0,0-2.05,2.38-1.92,3.71c0.13,1.34,2.96,1.65,4.87,0.35c1.92-1.3,3.14-3.29,3.14-3.29 v-7.04c0,0,1,1.34,2.64,0.25c1.64-1.09,1.7-3.77,0.75-4.74s-3-0.66-3.38,0.67c0,0-2.36,0.09-5.51-1.64 C152.98,26.05,151.77,23.09,151.56,21.21z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_775_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_776_",
    className: "st17",
    d: "M155.22,29.09c-0.02,0.35,0.24,0.65,0.58,0.66c0.34,0.02,0.62-0.25,0.64-0.6 c0.02-0.35-0.24-0.65-0.58-0.66C155.53,28.47,155.24,28.74,155.22,29.09z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_772_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_774_",
    className: "st18",
    d: "M154.52,33.2l-1.42,0.45c0.12,0.41,0.53,0.63,0.92,0.51 C154.41,34.04,154.64,33.61,154.52,33.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_770_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_771_",
    className: "st17",
    d: "M150.22,27.22l1.23-0.86c-0.23-0.35-0.68-0.45-1.03-0.21 C150.09,26.39,150,26.86,150.22,27.22z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_768_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_769_",
    className: "st17",
    d: "M150.51,28.65c-0.02,0.35,0.24,0.65,0.58,0.66c0.34,0.02,0.62-0.25,0.64-0.6 c0.02-0.35-0.24-0.65-0.58-0.66C150.81,28.03,150.52,28.3,150.51,28.65z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_765_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_766_",
    className: "st19",
    points: "153.49,28.3 153.39,31.97 151.46,31.37  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_762_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_764_",
    className: "st20",
    d: "M155.53,36.6c1.56-0.2,4.77-1.13,5.27-2.4c0,0-0.17,0.8-1.13,1.62 c-0.96,0.82-4.15,1.75-4.15,1.75V36.6z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_759_",
    className: "st8",
    d: "M159.93,67.75c2.64-0.62,4.31-3.29,3.62-5.92c-0.03-0.1-0.05-0.18-0.08-0.25 c-0.52-1.24-1.63-1.08-1.63-1.08l0,0c1.04-0.69,1.76-1.77,2.01-2.99l0.98-5.8c0,0,0.22-1.28-0.25-2.82l3.23-3.74 c0,0,0.23,0.16,0.6,0.41c0.5,1.62,0.43,3.38-0.13,5l-3.2,9.26c0,0,1.5,3.62,3.24,7.05c-5.92,3.3-12.92,2.89-17.17,1.14 C154.49,68.54,157.6,68.31,159.93,67.75z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_872_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_873_",
    className: "st14",
    d: "M176.53,62.75c-4.17-17.05-7.26-22.74-12.32-22.67c-1.48,1.77-1.07,7.11,1.27,10.35 c0,0,5.21,11,6.04,14.91c0.73,3.43,1.56,7.76,1.51,10.71c-0.01,0.52-0.22,1.02-0.58,1.4c-0.95,1.03-0.96,1.86-1.57,3 c-0.48,0.89-1.01,1.23-0.86,1.43c0.19,0.26,0.8,0.6,1.56,0.12c0.38-0.24,0.63-0.52,1.19-1.14c0,0-0.15,1.38-0.94,3.16 c-1.07,2.41-0.81,3.64,2.45,2.78c2.04-0.54,3.32-2.24,3.63-7.14c0.09-1.41,0.22-3.64,0.05-5.43 C177.52,69.58,177.2,65.49,176.53,62.75z"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2547_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2444_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2445_",
    className: "st14",
    d: "M135.15,111.49c0.45-16.59-0.88-20.57-5.3-23.61l-1.71,9.62c0,0,2.01,11.33,1.8,15.11 c-0.19,3.32-0.51,7.46-1.3,10.14c-0.14,0.47-0.46,0.87-0.88,1.14c-1.13,0.7-1.58,1.43-2.43,2.31c-0.66,0.69-1.23,0.87-1.14,1.09 c0.11,0.28,0.59,0.74,1.4,0.5c0.41-0.12,0.94-0.44,1.6-0.87c0,0-0.47,1.38-1.63,2.81c-1.58,1.93-1.65,3.12,1.54,3.15 c2,0.02,3.59-1.21,5.09-5.61c0.43-1.27,1.11-3.27,1.4-4.94C134.34,117.97,135.08,114.16,135.15,111.49z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2545_",
    className: "st21",
    d: "M126.13,86.62c2.11-0.31,4.98,0.14,6.83,3.45c1.85,3.31,2.31,9.01,2.52,14.67 c0,0-3.68,3.08-8.09,1.56L126.13,86.62z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_837_",
    className: "st3",
    d: "M126.13,86.62c2.11-0.31,4.98,0.14,6.83,3.45c1.85,3.31,2.31,9.01,2.52,14.67 c0,0-3.68,3.08-8.09,1.56L126.13,86.62z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2569_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2623_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2641_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2701_",
    className: "st13",
    d: "M132.33,177.89c0.33,0.13,0.42,0.76,0.47,2.03c0.04,0.96,0.24,2.63-0.88,2.97 c-1.12,0.33-2.77,0.16-3.49-0.74c-0.9-1.13-1.51-2.12-2.79-3.5c-1.11-1.19-2.32-2.31-2.77-3.99c-0.41-1.51-0.07-2.17,0.97-2.61 c1.42-0.61,3.65,1.37,4.77,1.68C129.57,174.01,132,177.77,132.33,177.89z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2640_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2699_",
    className: "st14",
    d: "M132.33,176.72v1.56c0,0-1.62,1.24-3.93,0.11c-0.07-0.15-0.41-2.23-0.41-2.23 L132.33,176.72z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2627_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2697_",
    className: "st13",
    d: "M119.72,186.87c0,0,0.45,1.35,0.69,2.54c0.19,0.94,0.47,2.51,0.14,3.22 c-0.33,0.71-1.62,1.17-3.61,1.15c-1.29-0.01-3.3,0.87-4.68,1.64c-1.42,0.79-4.38,1.11-5.89,0.93c-1.77-0.21-3.61-1.24-3.9-1.97 c-0.29-0.73,0.09-1.5,4.27-3.28c0.04-0.02,5.81-1.89,7.83-4.13L119.72,186.87z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2626_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2681_",
    className: "st14",
    d: "M119.72,185.18c0,0-0.01,1.16,0,1.82c0.01,0.66-0.77,1.64-2.79,1.57 c-1.42-0.05-2.41-0.43-2.35-1.6v-1.68L119.72,185.18z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2625_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2679_",
    className: "st15",
    d: "M133.35,156.05c-0.71-5.09-1.84-8.11-1.84-8.11s0.56-7,0.82-13.63 c0.29-7.17-0.02-16.17,0.12-17.96c0,0-23.12-4.68-23.53,3.6c-0.41,8.28,0.91,29.37,1.19,33.01c0.27,3.64,0.9,6.86,1.65,12.76 c0.74,5.82,2.82,19.57,2.82,19.57c2.64,1.43,5.14-0.11,5.14-0.11s1.63-16.56,1.46-20.76c-0.21-5.13-1.59-9.16-1.59-9.16 s0.44-6.83,0.83-12.77c0.39-5.94,0.8-8.79,0.89-11.38l0.5-0.25c0,0,0.51,10.25,0.78,13.89c0.27,3.64,0.85,7.13,1.9,13.89 c0.91,5.86,3.63,18.27,3.63,18.27c2.64,1.43,4.22-0.19,4.22-0.19S134.06,161.14,133.35,156.05z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2624_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2677_",
    className: "st16",
    d: "M121.3,131.11c0,0,5.61-2.76,8.42-5.26c0,0-2.61,3.67-6.03,5.3 c0,0-1.22,12.73-1.21,12.48l-0.7-12.54L121.3,131.11z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2620_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2621_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_2674_",
    className: "st14",
    points: "116.31,84 117.67,91.53 124.48,91.03 123.05,82.49  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2618_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2619_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2671_",
    className: "st6",
    d: "M131.66,90.48c-0.67-2.05-3.27-4.28-5.87-3.79c-4.78,0.89-8.56,1.84-11.38,2.84 c-2.38,0.85-4.55,2.91-4.74,10.73c0,0-0.8,18.25-0.81,21.78c5.98,2.36,12.19,2.29,15.63,1.54c7.15-1.56,8.01-4.53,8.01-4.53 s0.09-13.12-0.12-18.79C132.19,95.45,132.12,91.89,131.66,90.48z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2615_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2617_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2667_",
    className: "st22",
    d: "M111.06,74.84c0,0-1.72,2.75-1.52,3.01c0.21,0.26,1.53,0.47,1.53,0.47L111.06,74.84z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2616_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2665_",
    className: "st14",
    d: "M115.85,67.23c-3.6,0.84-4.6,2.46-4.82,8.2c-0.22,6.01,0.43,7.88,1.24,8.67 c0.54,0.53,3.5,0.57,4.99,0.12c1.86-0.56,6.04-2.15,7.95-5.21c2.24-3.6,2.75-8.43,0.21-10.35 C121.86,65.97,117.31,66.89,115.85,67.23z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M116.38,84.41c1.22-0.98,1.11-1.61,1.11-1.61c-0.88,0.82-4.11,1.52-5.22,1.31 C112.72,84.54,114.83,84.64,116.38,84.41z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2588_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2613_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2614_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2662_",
    className: "st17",
    d: "M111.07,68.72c1.06,1.81,3.35,2.67,3.35,2.67c0.69,0.79,0.31,3.85,1.52,4.34 c0,0,0.52-2.23,2.4-1.99c1.89,0.24,2.2,2.63,1.04,4.11c-1.15,1.48-2.27,0.95-2.27,0.95s0.13,3.17,1.57,4.93 c0,0,1.61,0.48,4.54-0.21c1.8-0.43,4.3-2.74,5.32-5.16c2.16-5.11,2.21-9.66-1.05-10.96c-0.4-2.32-2.26-3.33-4.36-3.76 c-4.53-0.93-7.45,1.89-10.93,1.65C110.21,65.15,109.84,66.61,111.07,68.72z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2591_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2612_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2659_",
    className: "st17",
    d: "M127.57,68.19l2.13-1.32c-0.37-0.59-1.14-0.77-1.73-0.41 C127.39,66.82,127.21,67.6,127.57,68.19z"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1769_",
    className: "st14",
    d: "M114.59,89.5c0,0-3.38,0.62-5.15,3.3c-1.77,2.67-9.41,12.26-9.41,12.26 s-10.99-5.5-11.53-6.15c-0.54-0.65-0.24-1.97-0.09-2.7c0.15-0.73,0.39-2.34,0.56-2.79c0.28-0.79-0.89-0.58-1.58,0.16 c-0.71,0.76-1,2.18-1.34,2.43c-0.34,0.25-2.96-2.76-4.23-4.21c-1.27-1.45-1.86-2.47-2.72-1.87c-0.61,0.43-0.22,1.29,0.69,2.54 c0.91,1.24,1.04,1.38,1.18,1.65c0.11,0.22-0.23,0.4-0.36,0.52c-0.25,0.22-0.68,0.58-0.71,0.93c-0.02,0.19,0.02,0.38-0.03,0.56 c-0.12,0.41-0.63,0.61-0.78,1.01c-0.1,0.29,0.01,0.62-0.05,0.93c-0.04,0.2-0.15,0.38-0.18,0.57c-0.07,0.39,0.15,0.77,0.41,1.07 c0.89,1.06,2.11,1.47,3.28,2.11c0.97,0.54,1.98,0.77,3.09,1.27c1.12,0.5,14.3,10.24,16.35,9.1c2.05-1.13,12.6-13.45,12.6-13.45 C117.65,93.67,114.59,89.5,114.59,89.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1766_",
    className: "st21",
    d: "M115.77,89.1c-1.45,0.17-3.49-0.1-6.34,2.96c-2.85,3.06-6.41,8.25-6.41,8.25 s0.99,4.96,6.37,6c0,0,4.99-5.11,6.37-7.92C117.16,95.57,117.48,91,115.77,89.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_836_",
    className: "st3",
    d: "M115.77,89.1c-1.45,0.17-3.49-0.1-6.34,2.96c-2.85,3.06-6.41,8.25-6.41,8.25s0.99,4.96,6.37,6 c0,0,4.99-5.11,6.37-7.92C117.16,95.57,117.48,91,115.77,89.1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectPosture);
export default __webpack_public_path__ + "static/media/select-posture.76932dfd7aadb231710ef692d15dae8b.svg";
export { ForwardRef as ReactComponent };